// extracted by mini-css-extract-plugin
export default {"Headline":"Home_Headline__7xFa2","cherish":"Home_cherish__KBeyk","navie":"Home_navie__ah-ly","burger":"Home_burger__Z0Q9v","head":"Home_head__tF-ep"};